const PIXEL_ID = "2255135375032166";
const CONSENT_KEY = "mira-cookie-consent";

let loaded = false;

const hasConsent = () => localStorage.getItem(CONSENT_KEY) === "all";

const loadPixel = () => {
  if (loaded || !PIXEL_ID) return;
  loaded = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

export const initMetaPixel = () => {
  if (hasConsent()) loadPixel();
};

export const metaConsentGranted = () => {
  loadPixel();
};

export const metaTrack = (event, custom = false, params = undefined) => {
  if (!loaded || !window.fbq) return;
  window.fbq(custom ? "trackCustom" : "track", event, params);
};

export const metaPageView = () => {
  if (!loaded || !window.fbq) return;
  window.fbq("track", "PageView");
};
